<template>
    <div>
        <v-card>
            <v-card-title>Add editorial</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-form ref="form" v-model="isValid">
                    <v-text-field
                        filled
                        label="Title"
                        :rules="validation.titleRules"
                        v-model="newsData.title"
                        @change="onTitleChange($event)"
                    ></v-text-field>
                    <redactor v-model="newsData.body"></redactor>
                    <br>
                    <v-text-field
                      label="Select publish date"
                      filled
                      clearable
                      readonly
                      :rules="validation.publishDateRules"
                      v-model="formattedDate"
                      @click:clear="dateClearCallback"
                      prepend-icon="mdi-calendar"
                      @click="showDatePicker"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>

                <v-btn
                    tile
                    color="primary"
                    class="mx-2"
                    v-on:click="submit"
                    :disabled="!isValid"
                    v-bind:loading="loading"
                    >Submit</v-btn
                >
                <v-spacer />
            </v-card-actions>
        </v-card>
        <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>

    </div>
</template>
<script>

import postApi from '@/api/postApi'
import snackbar from '@/utils/snackbar'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import commonUtils from '@/utils/commonUtils'
import redactor from '@/components/Redactor.vue'

export default {
  components: {
    DatePickerDialog,
    redactor
  },

  data () {
    return {
      isValid: null,
      imageData: '',
      loading: false,
      formattedDate: null,
      showDatePickerDialog: false,
      validation: {
        publishDateRules: [(v) => !!v || 'Publish date is required'],
        titleRules: [(v) => !!v || 'Enter title']
      },

      newsData: {
        title: '',
        body: '',
        is_for_subscriber: null,
        publish_date: null
      }

    }
  },
  watch: {
    'newsData.title': function (newVal, oldVal) {
      this.$log.info('title ', [newVal, oldVal])
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    }
  },
  methods: {
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.newsData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.newsData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    async submit () {
      this.loading = true
      try {
        this.$log.info('add editorial params', [this.newsData])
        if (this.newsData.body === '') {
          snackbar.show('Body is required', 'error')
          return
        }
        const response = await postApi.insertEditorial(this.newsData)
        if (response.data !== undefined) {
          if (response.data.id !== undefined) {
            this.newsData.title = ''
            this.newsData.body = ''
            // this.newsData.is_for_subscriber = null
            this.$refs.form.reset()
            snackbar.show('Editorial added successfully', 'success')
            window.publish_date = this.newsData.publish_date
            this.$router.push({ path: '/editorial', replace: true })
          }
        }
      } finally {
        this.loading = false
      }
    },
    onTitleChange (newVal, oldVal) {
      this.$log.info('Ontitle change', newVal, oldVal)
      this.newsData.title = commonUtils.parseStringForTri(newVal)
    }

  }
}
</script>

<style>
.ql-editor{
  min-height: 350px;
  font-size: 15px;
}
</style>
